import { render, staticRenderFns } from "./PartnerListFast.vue?vue&type=template&id=70d1cde6&scoped=true"
import script from "./PartnerListFast.vue?vue&type=script&lang=js"
export * from "./PartnerListFast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1cde6",
  null
  
)

export default component.exports